import axios from "axios";
import axiosInstance from "../../../axiosinterceptor";

export const getAuditRows = async (pageNo = 1, filters,flagauditRows,unassigned_page) => {
  const {header_id,file_type}=filters;
  const parsedArray=header_id.map((id)=>+id);
  const parsedFileType=file_type.flat();

  // let payload = "";
  // console.log("PAYLOAD::::", filters);
  // Object.entries(filters).map((filter) => {
  //   if (!filter[1]) {
  //     return;
  //   }
  //   if (typeof filter[1] === "string") {
  //     payload += `&${filter[0]}=${filter[1]}`;
  //     return;
  //   }
  //   filter[1].map((option) => {
  //     payload += `&${filter[0]}=${option}`;
  //   });
  // });
  // console.log("FILTERS:::::", { filters, payload });
  // const v4EndPoint =
  //   "https://x8zya18gei.execute-api.ap-southeast-2.amazonaws.com/filter_api_v4/";
  const v5EndPoint =
    // "https://60wr900wjd.execute-api.ap-southeast-2.amazonaws.com/hcp_data_filter_api_ics_v2";
     "/ics_hcp_data_filter_api_ics_v3"
    return await axiosInstance
    .post(
      v5EndPoint,
      {
        ...filters,
        page_number: pageNo,
        is_flagged:flagauditRows,
        unassigned_page:unassigned_page,
        header_id:parsedArray,
        file_type:parsedFileType
      },
    )
    .then((response) => {
      // const data = JSON.parse(response.data.body);
      const data = response.data;
      if (typeof data?.data === "string") {
        throw new Error(response.data.data);
      }
      const auditRows = data.data.audited_rows;
      return auditRows;
    })
    .catch((error) => {
      //console.log("Error in AuditRows Get request:", error);
      throw new Error(error.message);
    });
};

export const getauditData = async (hcp_line_id) => {
  try {
    const getapiEndpointv3 =
    "/ics_episode_details_ics_v2";
    const response=await axiosInstance.post(getapiEndpointv3,null,{
      params:{
        hcp_line_id:hcp_line_id,
      },
    });
    const auditData = response.data;
    return auditData; 
  } catch (error) {
    //console.log("Error in Auditdetail Get request:", error);
    throw new Error(error.message);
  }
  // return await axiosInstance
  //   .post(getapiEndpointv3, {
  //     params:{
  //       hcp_line_id:id,
  //     }
  //   })
  //   .then((response) => {
  //     const auditData = JSON.parse(response.data.body);
  //     return auditData.message;
  //   })
  //   .catch((error) => {
  //     console.log("Error in Auditdetail Get request:", error);
  //     throw new Error(error.message);
  //   });
};
export const getPallasReportData = async (payload) => {
  try {
    const url =
    "/pallas_algo_episode_data";
    const response=await axiosInstance.post(url,payload);
    console.log(response,'sdfgesrdgfh');
    
    const pallasreport = response.data;
    return pallasreport; 
  } catch (error) {
    //console.log("Error in Auditdetail Get request:", error);
    throw error;
  }
}
export const episodeUnAssignedUsers = async (selectedEpisodeRows, assginedById, addUnassignReason, isAllEpisodesSelected, filtersObj, recall_page,header_id) => {
  // console.log(selectedEpisodeRows, 'selectedEpisodeRows');
  // console.log(assginedById, 'assginedById');
  // console.log(addUnassignReason, 'addUnassignReason');
  // console.log(isAllEpisodesSelected, 'isAllEpisodesSelected');
  // console.log(filtersObj, 'filtersObj');
  // console.log(recall_page, 'recall_page');
  // console.log(header_id, 'header_id');
const unassginepayload = {
    hcp_lines: selectedEpisodeRows,
    unassigned_by: assginedById,
    unassignment_reason: addUnassignReason,
    select_all: isAllEpisodesSelected,
    user_id: assginedById,
    filter: {
      is_flagged: !recall_page ? !recall_page : false,
      insurer_identifier: filtersObj.insurerIdentifier ? filtersObj.insurerIdentifier : [] ,
      priority_value: filtersObj.priorityValue ? filtersObj.priorityValue : [],
      status: filtersObj.status ? filtersObj.status : [],
      coder_name: filtersObj.codedBy ? filtersObj.codedBy : [],
      header_id: header_id ? header_id : [],
      admission_date_from: filtersObj.fromAdmissionDate ? filtersObj.fromAdmissionDate : "",
      admission_date_to: filtersObj.toAdmissionDate ? filtersObj.toAdmissionDate : "",
      separation_date_from: filtersObj.fromSeparationDate ? filtersObj.fromSeparationDate : "",
      separation_date_to: filtersObj.toSeparationDate ? filtersObj.toSeparationDate : "",
      file_type: filtersObj.fileType ? filtersObj.fileType : [],
      length_of_stay: filtersObj.length_of_stay ? filtersObj.length_of_stay : [],
      assigned_by: filtersObj.assigned_by ? filtersObj.assigned_by : [],
      assigned_to: filtersObj.assigned_to ? filtersObj.assigned_to : [],
      case_mix_speciality: filtersObj.case_mix_speciality ? filtersObj.case_mix_speciality : [],
      page_number: filtersObj.page_number ? filtersObj.page_number : 1,
    }
  }
// const url = "https://nusk7ch374.execute-api.ap-southeast-2.amazonaws.com/ics_dev/unassignFunctionalityICSV1";
const url = "/ics_unassignFunctionalityICSV1";
  try {
    const response=await axiosInstance.post(url, unassginepayload);
    // console.log(response, "unassginepayload")
    const result = response.data;
    return result;
  } catch (error) {
    if(error.response.status === 401){
      return error;
    }else{
      throw new Error(error.message);
    }
  }
};

// Api to fetch the unassigned Episodes

export const fetchUnassignedEpisodes = async(assginedById,  filtersObj, recall_page,header_id,page_number,unassined_page)=>{
  // const url = "https://nusk7ch374.execute-api.ap-southeast-2.amazonaws.com/ics_dev/unassignedEpisodesICSV1"
  const url ="/ics_unassignedEpisodesICSV1"
  const fetchPaload = {
    user_id:assginedById,
    filters:{
      is_flagged:true,
      insurer_identifier: filtersObj.insurerIdentifier ? filtersObj.insurerIdentifier : [] ,
      priority_value: filtersObj.priorityValue ? filtersObj.priorityValue : [],
        status: filtersObj.status ? filtersObj.status : [],
        coder_name: filtersObj.codedBy ? filtersObj.codedBy : [],
        header_id: header_id ? header_id : [],
        admission_date_from: filtersObj.fromAdmissionDate ? filtersObj.fromAdmissionDate : "",
        admission_date_to: filtersObj.toAdmissionDate ? filtersObj.toAdmissionDate : "",
        separation_date_from: filtersObj.fromSeparationDate ? filtersObj.fromSeparationDate : "",
        separation_date_to: filtersObj.toSeparationDate ? filtersObj.toSeparationDate : "",
        file_type: filtersObj.fileType ? filtersObj.fileType : [],
        length_of_stay: filtersObj.length_of_stay ? filtersObj.length_of_stay : [],
        assigned_by: filtersObj.assigned_by ? filtersObj.assigned_by : [],
        assigned_to: filtersObj.assigned_to ? filtersObj.assigned_to : [],
        case_mix_speciality: filtersObj.case_mix_speciality ? filtersObj.case_mix_speciality : [],
        page_number: page_number ? page_number : 1,
        unassigned_by: []
    }
  }
  try {
    const response = await axiosInstance.post(url,fetchPaload)
  // console.log(response,"fetching unassigned episodes")
  const result = response.data.data;
  // console.log("result",response.data.data)
      return result;
  } catch (error) {
    if(error.response.status === 401){
      return error;
    }else{
      throw new Error(error.message);
    }
  }
  
  
}
export const getFilteredAuditData = async (filters,flagauditRows,unassined_page,pageNumber=1) => {
  
  const {header_id,file_type}=filters;
  const parsedArray=header_id.map((id)=>+id);
  const parsedFileType=file_type.flat();
 // const parsedFile=file_type.flat().map(str=>parseInt())
  // const getapiEndpoint =
  //   "https://nw71l5ckl4.execute-api.ap-southeast-2.amazonaws.com/webwork_flow_filter_api/";
  // const v3EndPoint ="https://os3wl7iyn2.execute-api.ap-southeast-2.amazonaws.com/workflow_filter_api_v3/"
  // const v4EndPoint =
  //   "https://x8zya18gei.execute-api.ap-southeast-2.amazonaws.com/filter_api_v4/";
  const v5EndPoint =
    // "https://60wr900wjd.execute-api.ap-southeast-2.amazonaws.com/hcp_data_filter_api_ics_v2";
    "/ics_hcp_data_filter_api_ics_v3"
  return await axiosInstance
    .post(v5EndPoint, {
      page_number:pageNumber,
        ...filters,
        is_flagged:flagauditRows,
        unassigned_page:unassined_page,
        header_id:parsedArray,
        file_type:parsedFileType
    })
    .then((response) => {
      if (response.data.errorMessage) {
        throw new Error(response.data.errorMessage);
      }
      const filteredAuditData = response.data.data.audited_rows;
      // console.log('filteredAuditData',filteredAuditData)
      return filteredAuditData;
    })
    .catch((error) => {
      //console.log("Error in FilteredAuditdetail  request:", error);
      throw new Error(error.message);
    });
};
export const getSearchData = async (searchData,filters,flagStatus,unassigned_page) => {
  const {header_id,file_type}=filters;

  const parsedArray=header_id.map((id)=>+id);
  const parsedFileType=file_type.flat();
  const url =
    // "https://onldssm3d6.execute-api.ap-southeast-2.amazonaws.com/search_by_episode_identifier_ics_v1";
    // "https://jvxxuwz5k1.execute-api.ap-southeast-2.amazonaws.com/search_by_episode_identifier_ics_v2";
    "/ics_hcp_data_filter_api_ics_v3";
  const params = {
    // episode_identifier: "I516064"
    episode_identifier: searchData,
   
    
  };
  return axiosInstance
    .post(url, { page_number:1,
        ...filters,
        is_flagged:flagStatus,
       unassigned_page:unassigned_page,
        episode_identifier:[searchData],
        header_id:parsedArray,
        file_type:parsedFileType })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      throw new Error(error.message);
    });
};

export const lastAuditdata = async(hcp_line_updated_at,page_number) =>{
  const url =
    `/ics_get_last_updated_at_or_recommendations_ics_v1`;
    const params = {
      page_number:page_number,
      hcp_line_updated_at:hcp_line_updated_at
    }
  try {
    const response = await axiosInstance.get(url,{params});
    return response.data;
  } catch (error) {
    throw new Error(error.message);
  }
}

export const uploadeByuser = async(uploaded_by_user_name,page_number) =>{
  const url =
    `/ics_get_uploaded_by_user_names_or_recommendations_ics_v1`;
    const params = {
      page_number:page_number,
      uploaded_by_user_name:uploaded_by_user_name
    }
  try {
    const response = await axiosInstance.get(url,{params});
    return response.data;
  } catch (error) {
    throw new Error(error.message);
  }
}

export const codedBynameUser = async(coder_name,page_number) =>{
  const url =`/ics_get_coded_by_user_names_or_recommendations_ics_v2`
  const params = {
    page_number:page_number,
    coder_name:coder_name
  }
  try{
    const response = await axiosInstance.get(url,{params})
    return response.data
  }catch(error){
  throw new error
  }
}








// export const getSearchData = async (searchData,flagStatus) => {
//   const url =
//     // "https://onldssm3d6.execute-api.ap-southeast-2.amazonaws.com/search_by_episode_identifier_ics_v1";
//     "https://jvxxuwz5k1.execute-api.ap-southeast-2.amazonaws.com/search_by_episode_identifier_ics_v2";
//   const params = {
//     // episode_identifier: "I516064"
//     episode_identifier: searchData,
//     is_flagged:flagStatus
//   };
//   return axiosInstance
//     .get(url, { params })
//     .then((response) => {
//       return response.data;
//     })
//     .catch((error) => {
//       throw new Error(error.message);
//     });
// };
export const getSearchRecommendations = async (filters,identifier,recall_page,unassigned_page) => {

  
  const url =
     "/ics_search_by_episode_identifier_recommendation_ics_v3"
  //  "https://nunoez6zh3.execute-api.ap-southeast-2.amazonaws.com/hcp_data_filter_api_ics_v4"
    // "https://x102zs3d9i.execute-api.ap-southeast-2.amazonaws.com/search_by_episode_identifier_recommendation_ics_v1";
    // "https://dgvqh8d2t4.execute-api.ap-southeast-2.amazonaws.com/search_by_episode_identifier_recomendation_ics_v2";
  try {
    const response = await axiosInstance.post(url, {
     ...filters,episode_identifier:[identifier.toUpperCase()],
     page_number:1,
     recall_page:recall_page,
     unassigned_page:unassigned_page
    });
    
    if(response.message){
      //console.log('messge',response.message,response);
      
      return response.message;
    }
    return response.data;
  } catch (error) {
    throw new Error(error.message);
  }
};
// export const getSearchRecommendations = async (identifier,flagStatus) => {
//   //console.log('string check',typeof(flagStatus),flagStatus);
  
//   const url =
//     // "https://x102zs3d9i.execute-api.ap-southeast-2.amazonaws.com/search_by_episode_identifier_recommendation_ics_v1";
//     "https://dgvqh8d2t4.execute-api.ap-southeast-2.amazonaws.com/search_by_episode_identifier_recomendation_ics_v2";
//   try {
//     const response = await axiosInstance.get(url, {
//       params: { episode_identifier: identifier.toUpperCase() ,is_flagged:flagStatus},
//     });
//     //console.log('response');
    
//     if(response.message){
//       //console.log('messge',response.message,response);
      
//       return response.message;
//     }
//     return response.data;
//   } catch (error) {
//     throw new Error(error.message);
//   }
// };

// export const getSearchRecommendations = async (filters,identifier,flagStatus) => {
//   //console.log('string check',typeof(flagStatus),flagStatus);
//   // console.log(filters);
//   // console.log(identifier)
//   // let pageNumber = 1;
//   // const {header_id,file_type}=filters;
//   // const parsedArray=header_id.map((id)=>+id);
//   // const parsedFileType=file_type.flat();
//   const url =
//   "https://nunoez6zh3.execute-api.ap-southeast-2.amazonaws.com/hcp_data_filter_api_ics_v4"
//     // "https://x102zs3d9i.execute-api.ap-southeast-2.amazonaws.com/search_by_episode_identifier_recommendation_ics_v1";
//     // "https://dgvqh8d2t4.execute-api.ap-southeast-2.amazonaws.com/search_by_episode_identifier_recomendation_ics_v2";
//   try {
//     // let currentPage = 1;
//     // let allData = [];
  
//     while(true){
//       const response = await axiosInstance.post(url, {
//         page_number:pageNumber,
//         ...filters,
//         episode_identifier:[identifier],
//         header_id:parsedArray,
//         file_type:parsedFileType
//       });
//       console.log('response',response.data.data.audited_rows);
//       if(response.data.data.audited_rows.length ===0)break;
      
//       allData = [...allData,...response?.data?.data?.audited_rows]
//       console.log(allData);
//       currentPage++;
//       if(response.message){
//         //console.log('messge',response.message,response);
        
//         return response.message;
//       }
//       return response.data;
//     }
//   } catch (error) {
//     throw new Error(error.message);
//   }
// };

export const getUsers = async (userName, pageNumber) => {
  const url =
    "/ics_get_user_names_or_recommendations_ics_v1";
    let queryParams = {};
    if (userName && userName.length > 0) {
      queryParams.user_name = userName;
      queryParams.page_number = pageNumber;
    } else {
      queryParams.page_number = pageNumber;
    }
  try {
    const response = await axiosInstance.get(url, {
      params: queryParams,
    });
    if(response.message){
      return response.message;
    }
    return response.data;
  } catch (error) {
    throw new Error(error.message);
  }
};
export const getShortDescriptions = async (shortDescription, pageNumber) => {
  const url =
    "/ics_get_short_description_or_recommendations_ics_v1";
    let queryParams = {};
    if (shortDescription && shortDescription.length > 0) {
      queryParams.short_description = shortDescription;
      queryParams.page_number = pageNumber;
    } else {
      queryParams.page_number = pageNumber;
    }
  try {
    const response = await axiosInstance.get(url, {
      params: queryParams,
    });
    if(response.message){
      return response.message;
    }
    return response.data;
  } catch (error) {
    throw new Error(error.message);
  }
};
export const getDrg = async (drg ,pageNumber)=>{
  const url = "/ics_getDrgCodesOrRecommendationsIcsV1"
  let queryParams = {};
  if(drg && drg.length > 0){
    queryParams.drg_code = drg
    queryParams.page_number = pageNumber
}
else{
  queryParams.page_number = pageNumber
}
try {
  const response = await axiosInstance.get(url,{params:queryParams})
  if(response.message){
    return response.message
  }
  return response.data
  
} catch (error) {
  throw new Error(error.message);
}
}
export const getReferenceIds = async (referenceID, pageNumber) => {
  const url =
    "/ics_get_reference_id_or_recommendations_ics_v1";
    let queryParams = {};
    if (referenceID && referenceID.length > 0) {
      queryParams.audit_ref_no = referenceID;
      queryParams.page_number = pageNumber;
    } else {
      queryParams.page_number = pageNumber;
    }
  try {
    const response = await axiosInstance.get(url, {
      params: queryParams,
    });
  
    if(response.message){
      return response.message;
    }
    return response.data;
  } catch (error) {
    throw new Error(error.message);
  }
};

export const episodeAssignedUsers = async (selectedEpisodeRows, selectedAssgineeUser, assginedById, addAssigeReason, isAllEpisodesSelected, filtersObj, recall_page,header_id,unassined_page) => {
  const assginePayload = {
    hcp_lines: selectedEpisodeRows ? selectedEpisodeRows : [],
    assigned_user_id: selectedAssgineeUser ? selectedAssgineeUser : null,
    assigned_by: assginedById ? assginedById : null,
    assignment_reason: addAssigeReason ? addAssigeReason : "",
    select_all: isAllEpisodesSelected,
    assignment:!unassined_page,
    filter: {
      insurer_identifier: filtersObj.insurerIdentifier ? filtersObj.insurerIdentifier : [] ,
      priority_value: filtersObj.priorityValue ? filtersObj.priorityValue : [],
      status: filtersObj.status ? filtersObj.status : [],
      file_type: filtersObj.fileType ? filtersObj.fileType : [],
      header_id: header_id ? header_id : [],
      coder_name: filtersObj.codedBy ? filtersObj.codedBy : [],
      admission_date_from: filtersObj.fromAdmissionDate ? filtersObj.fromAdmissionDate : "",
      admission_date_to: filtersObj.toAdmissionDate ? filtersObj.toAdmissionDate : "",
      separation_date_from: filtersObj.fromSeparationDate ? filtersObj.fromSeparationDate : "",
      separation_date_to: filtersObj.toSeparationDate ? filtersObj.toSeparationDate : "",
      length_of_stay: filtersObj.length_of_stay ? filtersObj.length_of_stay : [],
      assigned_by: filtersObj.assigned_by ? filtersObj.assigned_by : [],
      assigned_to: filtersObj.assigned_to ? filtersObj.assigned_to : [],
      case_mix_speciality: filtersObj.case_mix_speciality ? filtersObj.case_mix_speciality : [],
      page_number: filtersObj.page_number ? filtersObj.page_number : 1,
      is_flagged: recall_page ? recall_page : false
    }
  }
  try {
    const userAssignments =
    "/ics_episode_assignment_v1";
    const response=await axiosInstance.post(userAssignments,assginePayload);
    const episodeData = response.data;
    return episodeData;
  } catch (error) {
    if(error.response.status === 401){
      return error;
    }else{
      throw new Error(error.message);
    }
  }
};
export const auditStatusUpdate = async (auditDetails,flagauditRows) => {
  const {
    findings,
    comments,
    admission_date,
    seperation_date,
    sameday_status,
    episode_identifier,
    file_name,
    insurer_identifier,
    medical_record_number,
    name,
    current_drg_revenue,
    audit_status, // Destructure and omit findings
    ...otherAuditDetails // Collect all other properties
  } = auditDetails;
  const payload = {
    ...otherAuditDetails, // Spread other audit details excluding findings
    is_flagged: flagauditRows?true:false,
    status:auditDetails.audit_status // Set specific flag status
  };
  // const urlv3 =
  //   "https://svga801o97.execute-api.ap-southeast-2.amazonaws.com/work_flow_edit_audit_row_v3/";
  const urlv4 =
    "/ics_episode_edit_ics_v1";
  const response = await axiosInstance.put(urlv4,payload);
  if (response.data.errorMessage) {
    throw new Error(response.data.errorMessage);
  }
  const message = response.data.hcp_line_id;
  return message;
};
export const getAuditFiles = async (pageNumber = 1) => {
  const url =
    "/ics_get_header_file_ics_v1";
  try {
    const response = await axiosInstance.get(url,{
      params: {
        page_number: pageNumber,
      },
    });
    return response.data.data.headers;
  } catch (error) {
    throw new Error(error.message);
  }
};

export const getPassedRecords = async (pageNo) => {
  const url = `https://8yrsa3a6tf.execute-api.ap-southeast-2.amazonaws.com/get_passed_records_v1/?pageNumber=${pageNo}`;
  try {
    const response = await axios.get(url);
    if (typeof response.data?.message === "string") {
      throw new Error(response.data.message);
    }
    return response.data.message.audited_rows;
  } catch (error) {
    throw new Error(error.message);
  }
};

export const getPassedRecordsDetails = async (id) => {
  const url = `https://k5glluopp7.execute-api.ap-southeast-2.amazonaws.com/get_passed_records_detailed_v1/?id=${id}`;
  try {
    const response = await axios.get(url);
    return response.data.meesage;
  } catch (error) {
    throw new Error(error.message);
  }
};

export const getfilteroptionsdata = async () => {
  const url =
    // "https://imgg885g9b.execute-api.ap-southeast-2.amazonaws.com/filter_hcp_data_ics_v1/";
    "/ics_get_filter_options_ics_v2"
  try {
    const response = await axiosInstance.get(url);
    return response.data;
  } catch (error) {
    throw new Error(error.message);
  }
};
export const recall_episode = async (episodes) => {
  if(!sessionStorage.breadcrumbClick){
  const payload = {
    page_number: episodes.page_number,
  };
  const endPointUrl =
    "/ics_flagged_episodes_ics_v2";
    try {
      const response = await axiosInstance.post(endPointUrl, payload);
      return response;  
    } catch (error) {
      return error.message
    }
  }
};
export const flag_and_unflag = async (selectedEpisodeRows, selectedAssgineeUser, assginedById, addAssigeReason, isAllEpisodesSelected, filtersObj, recall_page,header_id) => {
  
  const payload = {
    hcp_lines: selectedEpisodeRows ? selectedEpisodeRows : [],
    select_all: isAllEpisodesSelected,
    filter: {
      insurer_identifier: filtersObj.insurerIdentifier ? filtersObj.insurerIdentifier : [] ,
      priority_value: filtersObj.priorityValue ? filtersObj.priorityValue : [],
      status: filtersObj.status ? filtersObj.status : [],
      file_type: filtersObj.fileType ? filtersObj.fileType : [],
      header_id: header_id ? header_id : [],
      coder_name: filtersObj.codedBy ? filtersObj.codedBy : [],
      admission_date_from: filtersObj.fromAdmissionDate ? filtersObj.fromAdmissionDate : "",
      admission_date_to: filtersObj.toAdmissionDate ? filtersObj.toAdmissionDate : "",
      separation_date_from: filtersObj.fromSeparationDate ? filtersObj.fromSeparationDate : "",
      separation_date_to: filtersObj.toSeparationDate ? filtersObj.toSeparationDate : "",
      length_of_stay: filtersObj.length_of_stay ? filtersObj.length_of_stay : [],
      assigned_by: filtersObj.assigned_by ? filtersObj.assigned_by : [],
      assigned_to: filtersObj.assigned_to ? filtersObj.assigned_to : [],
      case_mix_speciality: filtersObj.case_mix_speciality ? filtersObj.case_mix_speciality : [],
      page_number: filtersObj.page_number ? filtersObj.page_number : 1,
      is_flagged: !recall_page ? !recall_page : false
    },
    flag_episode_to:recall_page ? recall_page : false
  }
  const endPointUrl =
    "/ics_flag_unflag_episodes_ics_v1";
    try {
      const response = await axiosInstance.post(endPointUrl, payload);
      return response;  
    } catch (error) {
      return error.message
    }
};
// api calls for the workflow dashboard
export const getworkFlowDashBaord = async(pageNumber) =>{
  const url = "/ics_workflow_dashboard_fetch_files_ics_v1"
  try{
    const response = await axiosInstance.get(url,{ params: {
      page_number: pageNumber,
    },}
     
    )
    // console.log(response,"files");
    return response.data
  } catch(errorr){
    throw new Error(errorr.message)
  }
}

export const getFiltersOptionsData = async(dropdonwName,pageNumber)=>{
  const url = "/ics_get_filter_workflow_dashboard_v1";
  try {
    const response = await axiosInstance.get(url,{ params: {
      page_number: pageNumber,
      key:dropdonwName
    },});
    // console.log(response);
    return response.data;
  } catch (error) {
    throw new Error(error.message)
  }
}

export const getDoughnutData = async (filterOptions)=>{
  
  const url ="/ics_get_filters_pie_chart_v1";

  // const url ="https://9yoromuzh2.execute-api.ap-southeast-2.amazonaws.com/workflow_dashboard_doughnutchart_data";
  try {
    const response = await axiosInstance.post(url,
  {
      header_id:[...filterOptions?.headerId],
      insurer_identifier:[...filterOptions.insurerIdentifier],
      case_mix_speciality:[...filterOptions.caseMixSpeciality],
      length_of_stay:[...filterOptions.lengthOfStay],
      coder_name:[...filterOptions.codedBy],
      priority_value:[...filterOptions.priorityValue],
    
     selectallfiles:filterOptions.selectAllHeaderId,
     selectallspeciality:filterOptions.selectAllCaseMixSpecality,
     selectallcoder:filterOptions.selectAllCodedBy,
     selectallpriority:filterOptions.selectAllPriority,
     selectallinsurer:filterOptions.selectAllInsurerIdentifier

   }
  )
    // console.log(response)
    // console.log(response.data)
  
    return response.data;
  } catch (error) {
    throw new Error(error.message)
  }
}
export const getDrgErrorData = async (filterOptions)=>{
  const url ="/ics_drg_error_rate_calculation_v1";

  // const url ="https://6rr63q74wk.execute-api.ap-southeast-2.amazonaws.com/workflow_dashboard_drg_errordata";
  try {
    const response = await axiosInstance.post(url,{
       header_id:[...filterOptions?.headerId],
       insurer_identifier:[...filterOptions.insurerIdentifier],
       case_mix_speciality:[...filterOptions.caseMixSpeciality],
       length_of_stay:[...filterOptions.lengthOfStay],
       coder_name:[...filterOptions.codedBy],
       priority_value:[...filterOptions.priorityValue],
       selectallfiles:filterOptions.selectAllHeaderId,
     selectallspeciality:filterOptions.selectAllCaseMixSpecality,
     selectallcoder:filterOptions.selectAllCodedBy,
     selectallpriority:filterOptions.selectAllPriority,
     selectallinsurer:filterOptions.selectAllInsurerIdentifier
    })
    return response.data;
  } catch (error) {
    throw new Error(error.message)
  }
}
export const getDrgOptimizationData = async (filterOptions)=>{
  const url = "/ics_drg_optimisation_v1";

  // const url = "https://yp23242wy5.execute-api.ap-southeast-2.amazonaws.com/workflow_dashboard_drg_optimization";
  try {
    const response = await axiosInstance.post(url,{
      header_id:[...filterOptions?.headerId],
       insurer_identifier:[...filterOptions.insurerIdentifier],
       case_mix_speciality:[...filterOptions.caseMixSpeciality],
       length_of_stay:[...filterOptions.lengthOfStay],
       coder_name:[...filterOptions.codedBy],
       priority_value:[...filterOptions.priorityValue],
       selectallfiles:filterOptions.selectAllHeaderId,
       selectallspeciality:filterOptions.selectAllCaseMixSpecality,
       selectallcoder:filterOptions.selectAllCodedBy,
       selectallpriority:filterOptions.selectAllPriority,
       selectallinsurer:filterOptions.selectAllInsurerIdentifier
    })
  
    console.log(response.data)
    // console.log(res)
    // console.log(response.data.data)
    return response.data;
  } catch (error) {
    throw new Error(error.message)
  }
}
